import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFlipHorizontally16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconFlipHorizontally16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m4.147 12.989 8-1.188a1 1 0 0 0 .853-.99V9.504h1v1.309a2 2 0 0 1-1.706 1.978l-8 1.188A2 2 0 0 1 2 12V9.503h1V12a1 1 0 0 0 1.147.989M14 6.494h-1V5.181a1 1 0 0 0-.854-.989l-8-1.18A1 1 0 0 0 3 4v2.493H2V4.001a2 2 0 0 1 2.292-1.98l8 1.182A2 2 0 0 1 14 5.18zm.5 2.004a.5.5 0 0 0 0-1h-13a.5.5 0 0 0 0 1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFlipHorizontally16);
